<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-layout row align-center style="max-width: 800px">
        <v-autocomplete
          :items="FilteredFundersList"
          item-text="name"
          item-value="id"
          v-model="selectedProduct"
          label="Select a product"
          flat
          dense
          v-if="!screenIsWideEnough && FilteredFundersList.length > 1"
          class="mr-4 mt-2 ml-2"
        ></v-autocomplete>
        <v-text-field
          name="search"
          v-model="search"
          prepend-inner-icon="search"
          clearable
          flat
          placeholder="Search Funders"
          solo-inverted
          hide-details
          autocomplete="off"
          v-if="UserHasRole('Platform')"
        ></v-text-field>
        <v-select
          :items="filterableJourneys"
          item-text="name"
          item-value="id"
          v-model="filterByJourney"
          class="ml-3 mt-2"
          placeholder="Filter by Journey"
        ></v-select>
        <v-btn text @click="toggleShowDisabled">
          <span v-if="FunderIncludeDisabled"><v-icon class="mr-1">format_indent_decrease</v-icon> Hide Disabled</span>
          <span v-else><v-icon class="mr-1">format_indent_increase</v-icon> Show Disabled</span>
        </v-btn>
      </v-layout>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height">
        <v-layout :class="{ 'ml-0': !screenIsWideEnough, 'ml-4': screenIsWideEnough }">
          <v-flex
            style="overflow-y: auto;border-right: 1px solid #ddd;border-left: 1px solid #ddd;min-width:280px;max-width:280px;width:280px"
            :class="{ hidden: !screenIsWideEnough }"
          >
            <v-list class="pt-3" three-line dense v-if="SelectedFunder.id !== null" transparent>
              <template v-for="(products, provider) in FundersList">
                <v-subheader
                  class="text--accent-1 font-weight-bold"
                  v-if="PlatformUser()"
                  :key="provider.id"
                  v-text="provider"
                ></v-subheader>
                <v-subheader class="text--accent-1" v-else :key="provider.id">Products</v-subheader>
                <v-list-item
                  :class="{ selected: product.id === SelectedFunder.id }"
                  :key="product.id"
                  @click="selectFunder({ id: product.id, customerId: '' })"
                  v-for="product in products"
                  three-line
                >
                  <v-list-item-content :class="{ disabled: !product.enabled }">
                    <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">{{
                      product.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{ product.type.name }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ product.journey.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="provider.id"></v-divider>
              </template>
            </v-list>
          </v-flex>
          <v-flex>
            <v-card
              flat
              class="transparent"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent" />
                <v-tab key="enquiries" @click="selectTab('enquiries')">Enquiries</v-tab>
                <v-tab key="details" @click="selectTab('details')">Details</v-tab>
                <v-tab key="users" @click="selectTab('users')">Users</v-tab>
                <v-tab key="fees" @click="selectTab('fees')" v-if="PlatformUser()">Fees</v-tab>
                <v-tab key="answers" @click="selectTab('answers')">Answers</v-tab>
                <v-tab key="comms" @click="selectTab('comms')">Comms</v-tab>
                <v-tab key="options" @click="selectTab('options')" v-if="PlatformUser()">Company Options</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item key="enquiries">
                  <funder-enquiries :product="product"></funder-enquiries>
                </v-tab-item>
                <v-tab-item key="details">
                  <funder-details :selectedProduct="selectedProduct"></funder-details>
                </v-tab-item>
                <v-tab-item key="users">
                  <funder-users></funder-users>
                </v-tab-item>
                <v-tab-item key="fees" v-if="PlatformUser()">
                  <fees></fees>
                </v-tab-item>
                <v-tab-item key="answers">
                  <answers-container :selectedProduct="selectedProduct"></answers-container>
                </v-tab-item>
                <v-tab-item key="comms">
                  <funder-comms :product="selectedProduct" />
                </v-tab-item>
                <v-tab-item key="options" v-if="PlatformUser()">
                  <business-details :selectedProduct="selectedProduct"></business-details>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-speed-dial
        v-model="fab"
        direction="top"
        fixed
        bottom
        right
        open-on-hover
        transition="slide-y-transition"
        v-if="UserHasRole('Platform')"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="accent darken-1" dark fab>
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>add</v-icon>
          </v-btn>
        </template>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" color="primary" dark @click.stop="showNewFunder = true">
              <v-icon>fa-coins</v-icon>
            </v-btn>
          </template>
          <span>Add new Funder</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" color="primary" dark @click.stop="showNewProduct = true">
              <v-icon>fa-credit-card</v-icon>
            </v-btn>
          </template>
          <span>Add new Product</span>
        </v-tooltip>
      </v-speed-dial>
      <v-btn fab dark color="accent darken-1" @click.stop="showNewProduct = true" bottom right fixed v-else>
        <v-icon>add</v-icon>
      </v-btn>
    </v-content>
    <new-product-dialog :show.sync="showNewProduct" :selectedFunder="selectedProduct"></new-product-dialog>
    <new-funder-dialog :show.sync="showNewFunder"></new-funder-dialog>
    <new-user-dialog
      :show.sync="showNewUser"
      :selectedBusinessId="SelectedFunder.provider.id"
      :selectedBusinessName="SelectedFunder.provider.name"
      @success="refreshFunder"
    ></new-user-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import AnswersContainer from './Answers/AnswersContainer';
import BusinessDetails from './Details/BusinessDetails';
import Fees from './Fees/Fees';
import FunderDetails from './Details/FunderDetails';
import FunderEnquiries from './Enquiries/FunderEnquiries';
import FunderUsers from './Users/FunderUsers';
import NewFunderDialog from './NewFunderDialog';
import NewProductDialog from './NewProductDialog';
import NewUserDialog from './NewUserDialog';
import FunderComms from '@/components/Platform/Funders/FunderComms';

export default {
  components: {
    FunderComms,
    AnswersContainer,
    BusinessDetails,
    Fees,
    FunderDetails,
    FunderEnquiries,
    FunderUsers,
    NewFunderDialog,
    NewProductDialog,
    NewUserDialog
  },
  name: 'funders',
  data: () => ({
    tabs: null,
    fab: false,
    showNewProduct: false,
    showNewFunder: false,
    showNewUser: false,
    activeTab: 'enquiries',
    selected: [],
    product: {
      logo: null,
      type: {
        id: null
      },
      journey: {
        id: null
      },
      provider: {
        users: [
          {
            id: null
          }
        ]
      }
    }
  }),
  computed: {
    ...mapGetters([
      'FunderEnquiries',
      'FundersList',
      'FunderSearch',
      'FunderJourneyFilter',
      'FunderIncludeDisabled',
      'SelectedFunder',
      'UILeftDrawer',
      'PlatformUser',
      'ProductTypes',
      'UserHasRole',
      'Groups',
      'Questions',
      'JourneyTypes'
    ]),
    selectedProduct: {
      get() {
        return this.product;
      },
      set(id) {
        this.product = this.selectFunder({ id, customerId: '' });
      }
    },
    search: {
      get() {
        return this.FunderSearch;
      },
      set: _.debounce(function(value) {
        this.setFunderSearch(value).then(() => this.getFundersList());
      }, 350)
    },
    filterByJourney: {
      get() {
        return this.FunderJourneyFilter;
      },
      set(journeyId) {
        this.setFunderJourneyFilter(journeyId).then(() => this.getFundersList());
      }
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    FilteredFundersList() {
      return _.flatten(_.values(this.FundersList));
    },
    filterableJourneys() {
      return _.isNull(this.JourneyTypes[0].id) ? [] : this.JourneyTypes[1].journeys;
    }
  },
  methods: {
    ...mapActions([
      'getFundersList',
      'selectFunder',
      'updateUILeftDrawerState',
      'getFeeTiers',
      'getProductTypes',
      'addNotification',
      'setFunderSearch',
      'setFunderJourneyFilter',
      'unsetFunderJourneyFilter',
      'showDisabled',
      'getOwnersList',
      'getGroups',
      'getQuestions',
      'getJourneyTypes'
    ]),
    selectTab(tabName) {
      this.activeTab = tabName;
    },
    clearSearch() {
      this.toggles = [];
      this.search = '';
      this.includeDisabled = false;
      this.showDisabled(false);
      this.setFunderSearch('').then(() => this.getFundersList());
    },
    refreshFunder() {
      this.addNotification({
        text: `User added - please refresh to see details`
      });
    },
    toggleShowDisabled() {
      this.showDisabled(!this.FunderIncludeDisabled).then(() => this.getFundersList());
    },
    toSlug(value) {
      return value.toLowerCase().replace(/\s/g, '-');
    }
  },
  mounted() {
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
    if (_.isNull(this.Questions[0].id)) {
      this.getQuestions();
    }
    if (_.isNull(this.Groups[0].id)) {
      this.getGroups();
    }

    this.getFundersList();
    this.getProductTypes();
    this.getOwnersList();
  },
  watch: {
    SelectedFunder: function(product) {
      this.product = _.clone(product);
    },
    includeDisabled: function(include) {
      this.showDisabled(include).then(() => this.getFundersList());
    }
  }
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.responsive {
  width: 100%;
  max-width: 135px;
  height: auto;
}

.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

.theme--light .input-group.input-group--solo-inverted.input-group--focused {
  background-color: #fff;

  ::v-deep input,
  ::v-deep .input-group__prepend-icon {
    color: rgba(0, 0, 0, 0.78);
  }
}

.btn-toggle--selected {
  box-shadow: none;

  .btn--active {
    color: #e91e63;

    > .btn__content:before {
      opacity: 0;
    }
  }
}

.hidden {
  display: none;
}

.theme--light {
  .subheader.text--accent-1 {
    color: #e91e63;
  }

  &.v-list {
    background: inherit;
  }
}

::v-deep .disabled {
  color: rgba(0, 0, 0, 0.54);
  text-decoration: line-through;
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

.filter-header {
  margin-top: 6px;
  float: left;
}

::v-deep .v-list__tile.v-list__tile--link.theme--light {
  border-radius: 0 !important;
}
</style>
